import axios from 'axios'

// For calls that wait on Gaia through core-api. core-api gives up on Gaia
// after 30s (api/config/gaia.js) and returns its fallback, so this leaves room
// for that response to arrive while still never waiting forever.
export const GAIA_TIMEOUT_MS = 35000;

export default class API {
	base = process.env.API_BASEURL;

	constructor() {
		this.get = this.get.bind(this)
		this.post = this.post.bind(this)
		this.put = this.put.bind(this)
	}

	// Dynamic headers - read fresh values on each request
	getHeaders() {
		const member = JSON.parse(localStorage.getItem('authUser'));
		return {
			headers: {
				"x-api-key": member ? member.memberID : "",
				"Authorization": `Bearer ${localStorage.getItem('id_token')}`,
				"Content-Type": "application/json",
				"x-tenant-id": localStorage.getItem('community_id')
			}
		};
	}

	get(route) {
		return axios.get(this.base + route, this.getHeaders());
	}
	// `config` is extra axios request config, e.g. { timeout: GAIA_TIMEOUT_MS }.
	post(route, data, config = {}) {
		return axios.post(this.base + route, data, { ...config, ...this.getHeaders() });
	}
	put(route, data) {
		return axios.put(this.base + route, data, this.getHeaders());
	}
}



// WEBPACK FOOTER //
// ./src/services/API.js